
export const TRANSITION_CLASS_RIGHT = 'leaving-right';
export const TRANSITION_CLASS_LEFT = 'leaving-left';
export const ENTRANCE_CLASS_RIGHT = 'entering-right';
export const ENTRANCE_CLASS_LEFT = 'entering-left';
export const CENTER_CLASS = 'center';

export const TRANSITION_DURATION = 1.15;

export const NAVBAR_HEIGHT = 60;

export const NAINITAL = 'Nainital';
export const MAHABALIPURAM = 'Mahabalipuram';
export const MYSORE = 'Mysore';